<template>
  <swiper :options="swiperOptions" class="banner-carousel">
    <swiper-slide v-for="(image, index) in imageList" :key="index">
      <div class="banner-item">
        <img :src="image" alt="Slide Image" class="banner-image" />
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-next" slot="button-next"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
  </swiper>
</template>

<script>
import { Swiper as SwiperClass, Pagination, Navigation, Autoplay } from 'swiper';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
import 'swiper/swiper-bundle.css';

// 使用 Swiper 模块
SwiperClass.use([Pagination, Navigation, Autoplay]);

const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);

export default {
  name: 'BannerCarousel',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    pics: {
      type: String,
      default: '',
    },
  },
  computed: {
    imageList() {
      return this.pics.split(',').map(url => url.trim()).filter(url => url);
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1.8, // 每次显示1.5张图片
        spaceBetween: 0, // 图片间距
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
};
</script>

<style scoped>
.banner-carousel {
  width: 100%; /* 设置轮播容器宽度 */
  margin: 0 auto; /* 居中对齐 */
}

.banner-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  margin: 20px;
  overflow: hidden;
}

.banner-image {
  max-height: 100%;
  width: auto;
}
</style>
